// extracted by mini-css-extract-plugin
module.exports = {"underline-offset-9":"styles_underline-offset-9__oK2yi","w-fit":"styles_w-fit__2GXp6","basis-6":"styles_basis-6__4w67H"};